<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong> Extraction des dossiers DBCO</strong>
      </b-card-header>
      <b-card-body>
        <b-card-text>Les dates correspondent à celles où les dossiers sont passés au statut "Traité"</b-card-text>
        <b-row>
          <b-col sm="5">
            <b-form-group
              label-for="dateDebut"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Date de début :</b></template>
              <b-form-input class="custom-input-reduit"
                            type="date"
                            id="dateDebut"
                            @paste="onPaste($event, 'debut')"
                            v-model="dateDebut"
                            :class="{hasError: errors.date_debut !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.date_debut }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="5">
            <b-form-group
              label-for="dateFin"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Date de fin :</b></template>
              <b-form-input type="date"
                            id="dateFin"
                            @paste="onPaste($event, 'fin')"
                            v-model="dateFin">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5">
            <b-form-group
              label-for="isConforme"
              :label-cols="3"

              :horizontal="true">
              <template slot="label"><b>Conformité :</b></template>
              <b-form-radio-group id="isConforme" v-model="isConforme" name="isConforme" :class="{hasError: errors.isConforme !== ''}">
                <b-form-radio value="true">Conforme</b-form-radio>
                <b-form-radio value="false">Non conforme</b-form-radio>
              </b-form-radio-group>
              <span class="field-error">{{ errors.isConforme }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="5">
            <b-form-group
              label-for="dbcoType"
              :label-cols="3"

              :horizontal="true">
              <template slot="label"><b>Type :</b></template>
              <b-form-radio-group id="dbcoType" v-model="dbcoType" name="dbcoType" :class="{hasError: errors.dbcoType !== ''}">
                <b-form-radio value="DB">DB</b-form-radio>
                <b-form-radio value="CO">CO</b-form-radio>
              </b-form-radio-group>
              <span class="field-error">{{ errors.dbcoType }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <div>
          <b-button class="mt-2 mb-1 mr-1" variant="info" @click="generateExcel">Génerer</b-button>
        </div>

      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import { checkSIREN, downloadFile, isEmpty } from '@/utils/fileHelper';
  import moment from 'moment';

  export default {
    name: "ExtractionDossierDBCO",
    data() {
      return {
        dateDebut: null,
        dateFin: null,
        isConforme: null,
        dbcoType: '',
        errors: {
          date_debut: '',
          isConforme: '',
          dbcoType: '',
        }
      }
    },
    created() {
      // this.$axios.defaults.baseURL = getBaseUrl();
      // this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      // this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      // this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      generateExcel() {
        let self = this;
        this.clearErrors();
        if(this.validateForm()) {
          let data = {
            date_debut: this.dateDebut,
            date_fin: this.dateFin,
            isConforme: this.isConforme,
            dbcoType: this.dbcoType,
          };
          let conformite = this.isConforme === 'true' ? 'conforme' : 'non_conforme';
          let filename = 'extraction_ar_'+conformite+'_dbco_du_' + this.formatDate(this.dateDebut);
          if (this.dateFin) {
            filename = filename + '_au_' + this.formatDate(this.dateFin);
          } else {
            filename = filename + '_a_aujourd_hui';
          }
          this.$store.commit('IS_LOADING', true);
          if (!isEmpty(process.env.VUE_APP_MIDDLE_EXTRACT_URL)) {
            this.$axios.defaults.baseURL = process.env.VUE_APP_MIDDLE_EXTRACT_URL;
          }
          this.$axios
            .post(`/espaceGestion/extractions/extraction-ar-courrier-dbco`, data, {responseType: "arraybuffer"})
            .then(response => {
              this.$store.commit('IS_LOADING', false);
              
              downloadFile(response, filename, 'csv', '_BLANK')
              // this.downloadExportedFile(response, `${this.fileName}.xlsx`);
            })
            .catch(function(error){
              console.log(error)
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la génération du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
            });
        }
      },
      onPaste(evt, type) {
        evt.stopPropagation();
        evt.preventDefault();
        let clipboardData = evt.clipboardData || window.clipboardData;
        let pastedData = clipboardData.getData('Text');
        pastedData = moment(pastedData, 'DD/MM/YYYY').format('YYYY-MM-DD');
        if (type === 'debut') {
          this.dateDebut = this.formatDate(pastedData);
        } else if (type === 'fin') {
          this.dateFin = this.formatDate(pastedData);
        }
      },
      clearErrors() {
        this.errors.date_debut = '';
        this.errors.isConforme = '';
        this.errors.dbcoType = '';
      },
      validateForm() {
        let valid = true;
        if (this.dateDebut === '' || this.dateDebut === null) {
          this.errors.date_debut = 'La date de début est obligatoire';
          valid = false;
        }

        if (isEmpty(this.isConforme)) {
          this.errors.isConforme = 'Vous devez choisir entre les AR conforme et non conforme';
          valid = false;
        }

        if (isEmpty(this.dbcoType)) {
          this.errors.dbcoType = 'Vous devez choisir le type de document : DB ou CO';
          valid = false;
        }

        return valid;
      },
    }
  }
</script>

<style scoped>

  .prune-medium {
    background-color: #C0504D;
    color: #FFFFFF;
  }

  .center {
    text-align: center;
  }
</style>
